import gql from "graphql-tag";
import actionFormContainer from "./actionFormContainer";
import {cancelShipClientDispatch, successShipClientDispatch} from "../../../actions/ClientDispatchApiActions";

export default actionFormContainer({
  mutation: gql`
    mutation shipClientDispatch($data: ClientDispatchIdInput!) {
      shipClientDispatch(input: $data) {
        errors { key message }
      }
    }
  `,
  resultField: "shipClientDispatch",
  buildData: (props) => ({clientDispatchId: props.clientDispatchId}),
  formProps: () => ({
    submitLabel: "Ship",
    message: "Ship this dispatch? The stock is drawn down from the origin warehouse (unless it is the factory), and every container on it is recorded as delivered to the client. Serial numbers not on it yet can be added afterwards. A shipped dispatch cannot be cancelled.",
  }),
  success: successShipClientDispatch,
  cancel: cancelShipClientDispatch,
});
